define('ordersDetailOrderProductOptionEditMixableOptionCategoryView',[
  'module',
  'backbone',
  'marionette',
  'underscore',  
  'selectView',  
  'template!ordersDetailOrderProductOptionEditMixableOptionCategoryView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  SelectView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,   
    className: 'category-view',

    regions: {
      'select-region': '.select-region'
    },

    onRender: function() {
      this.collection = new Backbone.Collection();

      _.each(this.model.get('category').productOptions, function(option) {
        this.collection.add({
          id: option.id,
          value: option.name
        });
      }, this);
      this.selectView = new SelectView({
        collection: this.collection
      });
      this.getRegion('select-region').show(this.selectView);
      
      if(this.model.get('option'))
        this.selectView.setSelected(this.model.get('option').id);     
    }
  });
});
